import React, { useEffect, useState } from "react";
import { Col, Row, Card, Button, Form, Select, Spin, Input, Modal } from "antd";
import { useNavigate } from "react-router";
import Main from "../../components/layout/Main";
import "../../assets/styles/dashboard.css"
import Dashboard01 from "../../assets/images/icon/dashboard.svg";

const { Option } = Select;
const modules = [
  {
    title: "Dashboard",
    class: "module yellow",
    icon: Dashboard01,
    path: "/dashboard",
  },
  {
    title: "File Manager",
    class: "module orange",
    icon: Dashboard01,
    path: "/file-manager",
  },
  {
    title: "Location Manager",
    class: "module blue",
    icon: Dashboard01,
    path: "/location-manager",

  },
  {
    title: "Project Manager",
    class: "module lightblue",
    icon: Dashboard01,
    path: "/project-manager",

  },

  {
    title: "Top Data",
    class: "module red",
    icon: Dashboard01,
    path: "/top-data",

  },
  {
    title: "DB Coloum",
    class: "module pink",
    icon: Dashboard01,
    path: "/db-coloum",

  },
  {
    title: "Profile",
    class: "module red",
    icon: Dashboard01,
    path: "/profile",

  },
  // {
  //   title: "Category Manager",
  //   class: "module purple",
  //   icon: Dashboard01,

  // },
  // {
  //   title: "product-manager",
  //   class: "module blue",
  //   icon: Dashboard01,

  // },

  // {
  //   title: "Notification Manager",
  //   class: "module green",
  //   icon: Dashboard01,
  //   path: "",

  // },
  // {
  //   title: "content-manager",
  //   class: "module blue",
  //   icon: Dashboard01,
  //   path: "",

  // },
  // {
  //   title: "Email Templates",
  //   class: "module green",
  //   icon: Dashboard01,
  //   path: "",

  // },

  //   { title: "Vendor Assessments", class: "module blue", icon: Dashboard01 },
  //   { title: "Privacy Notice Management", class: "module blue", icon: Dashboard01 },
  //   { title: "Workflow Orchestration", class: "module dark", icon: Dashboard01 },
  //   { title: "PrivacyOps Center", class: "module blue", icon: Dashboard01 },
];

const footerLinks = [
  "Settings", "Data Systems", "Deployment", "Message Center", "Audit Log", "Knowledge Center"
];

const DashboardNewIndex = () => {
  const navigate = useNavigate();

  return (
    <Main>
      <div className="dashboard-container">
        <div className="modules-grid">
          {modules.map((item, i) => (
            <div key={i} className={item.class} onClick={() => item.path && navigate(item.path)}>
              <div className="hexagon">
                <div className="hexagon-inner">
                  <img src={item.icon} alt="icon" className="hex-icon" />
                </div>
              </div>
              <p>{item.title}</p>
            </div>
          ))}
        </div>

        {/* <div className="footer-grid">
          {footerLinks.map((link, i) => (
            <div key={i} className="footer-item">
              {link}
            </div>
          ))}
        </div> */}
      </div>
    </Main>
  );
};


export default DashboardNewIndex;
